import { minifyString } from './index.js';

// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable prefer-spread */
/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable no-var */
/* eslint-disable vars-on-top */
/* eslint-disable func-style */
/* eslint-disable func-names */
/* eslint-disable prefer-destructuring */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable prefer-rest-params */
/* eslint-disable object-shorthand */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable @typescript-eslint/no-unused-vars */
// @ts-nocheck
const defineTagManager = function (w, d, l, gl, yaid) {
    var googleDataLayer = w[gl];
    function TagManager() { }
    TagManager.prototype.get = function (key) {
        var dataObject = w[l].reduce(function (acc, data) {
            return Object.assign(acc, data);
        }, {});
        return dataObject[key];
    };
    TagManager.prototype.getIsEvent = function (element) {
        return Object.prototype.hasOwnProperty.call(element, 'event');
    };
    TagManager.prototype.getIsUserId = function (element) {
        return Object.prototype.hasOwnProperty.call(element, 'SravniUserId');
    };
    TagManager.prototype.emitYandexEvent = function (event) {
        var eventType = event.event;
        switch (eventType) {
            case 'pageViewGA':
                return this.emitYandexHitEvent(event);
            case 'mainEvent':
            case 'adEvent':
                return this.emitYandexReachGoalEvent(event);
        }
    };
    TagManager.prototype.emitYandexUserId = function (element) {
        w.ym(yaid, 'setUserID', element.SravniUserId);
    };
    TagManager.prototype.emitYandexHitEvent = function (event) {
        var path = event.path;
        var title = event.title;
        w.ym(yaid, 'hit', path, {
            title: title,
            referer: d.referrer || '',
            params: {
                theme: this.get('theme'),
                abTestingStatistics: this.get('abTestingStatistics'),
                analyticsId: this.get('analyticsId'),
            },
        });
    };
    TagManager.prototype.emitYandexReachGoalEvent = function (event) {
        var createEventType = function (event) {
            var eventCategory = event.eventCategory || '';
            var eventAction = event.eventAction || '';
            var eventType = `${eventCategory}_${eventAction}`.replace(/[\s\|]/g, '_');
            var adaptEventType = function (eventType) {
                var templates = [
                    'Кредитные_карты_Платный_клик',
                    'Микрокредиты_Платный_клик',
                    'РКО_Платный_клик',
                    'Ипотека_Платный_клик',
                    'Вклады_Платный_клик',
                    'Дебетовые_карты_Платный_клик',
                    'Кредиты_Платный_клик',
                ];
                var newEventType = templates.find(function (template) {
                    return eventType.indexOf(template) === 0;
                });
                return newEventType || eventType;
            };
            return adaptEventType(eventType);
        };
        var goalEventType = createEventType(event);
        var eventCategory = event.eventCategory || '';
        var eventAction = event.eventAction || '';
        var eventLabel = event.eventLabel;
        var eventValue = event.eventValue;
        var pagePath = event.path || w.location.pathname || '';
        var theme = this.get('theme');
        var abTestingStatistics = this.get('abTestingStatistics');
        var analyticsId = this.get('analyticsId');
        var goalParams = {
            eventCategory: eventCategory,
            eventAction: eventAction,
            eventLabel: eventLabel,
            eventPagePath: pagePath,
            eventCategoryAction: goalEventType,
            theme: theme,
            abTestingStatistics: abTestingStatistics,
            analyticsId: analyticsId,
        };
        if (eventValue) {
            goalParams.eventValue = eventValue;
            goalParams.order_price = eventValue;
            goalParams.currency = 'RUB';
        }
        w.ym(yaid, 'reachGoal', goalEventType, goalParams);
    };
    TagManager.prototype.convertToGoogleMetrics = function (data) {
        googleDataLayer.push.apply(googleDataLayer, data);
    };
    TagManager.prototype.convertToYandexMetrics = function (data) {
        for (var index = 0; index < data.length; index++) {
            var element = data[index];
            var isEvent = this.getIsEvent(element);
            var isUserId = this.getIsUserId(element);
            if (isEvent)
                this.emitYandexEvent(element);
            if (isUserId)
                this.emitYandexUserId(element);
        }
    };
    TagManager.prototype.convertToMetrics = function (data) {
        this.convertToGoogleMetrics(data);
        this.convertToYandexMetrics(data);
    };
    w.sravni_tag_manager = new TagManager();
};
const decorateSravniDataLayer = function (w, _d, l) {
    var a = w[l];
    if (typeof a !== 'undefined' && a.push.toString().indexOf('[native code]') === -1)
        return;
    if (typeof w.sravni_tag_manager === 'undefined')
        return;
    if (typeof a.push === 'function') {
        w.sravni_tag_manager.convertToMetrics(a);
        var b = a.push;
        a.push = function () {
            var a = b.apply(this, arguments);
            w.sravni_tag_manager.convertToMetrics([].slice.call(arguments, 0));
            return a;
        };
    }
};
const defineSravniTM = (options) => {
    const { dataLayer, googleDataLayer, yandexId } = options;
    const response = [
        `(${defineTagManager.toString()})(window, document, '${dataLayer}', '${googleDataLayer}', '${yandexId}')`,
        `(${decorateSravniDataLayer.toString()})(window, document, '${dataLayer}')`,
    ];
    return minifyString(response.join(';\n'));
};

export { defineSravniTM };
//# sourceMappingURL=sravniTm.js.map
